import ModalDialog, { ModalCloseHandler } from 'src/components/ModalDialog';
import DataTable, {
  DataTableWrapper,
  useTableQueryParams,
} from 'src/components/DataTable';
import { useAppConfig } from 'src/config';
import { ClusterPod } from 'src/pages/Sites/types';
import PodVersionCell from './PodVersionCell';
import { getExpectedVersion } from '../utils';
import ExpectedVersionCell from './ExpectedVersionCell';

const columns = [
  { id: 'podName', title: 'Pod Name' },
  { id: 'imageName', title: 'Image Name' },
  { id: 'imageVersion', title: 'Version', Component: PodVersionCell },
  {
    id: 'expectedVersion',
    title: 'Expected Version',
    Component: ExpectedVersionCell,
  },
];

type Props = {
  open: boolean;
  onClose: ModalCloseHandler;
  namespaceName: string;
  pods: ClusterPod[];
};

function NameSpacePodsModal({ open, onClose, namespaceName, pods }: Props) {
  const { paging, sorting } = useTableQueryParams();
  const { edgePlatformStandardVersion } = useAppConfig();

  const data = pods.map((pod) => ({
    ...pod,
    expectedVersion: getExpectedVersion(pod.imageName, edgePlatformStandardVersion),
  }));

  return (
    <ModalDialog
      open={open}
      title={`Pods — ${namespaceName}`}
      showCancelBtn={true}
      showConfirmBtn={false}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      titleStyle={{ fontWeight: '500' }}
    >
      <DataTableWrapper searchBar={false}>
        <DataTable columns={columns} data={data as any} {...paging} {...sorting} />
      </DataTableWrapper>
    </ModalDialog>
  );
}

export default NameSpacePodsModal;
